module.exports = __webpack_public_path__ + "static/ANGACOM_events-mobile-hero-da09a9ae2f3ff7394e00beba6eddf1b5.jpg";